/* eslint-disable max-lines-per-function */
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { calculateHoursSum } from '@/domain/mitarbeiter/features/anlageassistent/utils/calculateHoursSum';
import { Body } from '@e2n/ui/v2';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function StundenWoche() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const [summeStunden, setSummeStunden] = useState('');

  const handleSummenCalculation = () => {
    const wochenstunden =
      form.state.values.bezahlung.arbeitszeitkonto.gehaltsempfaenger
        .wochenstunden;
    const ueberstunden =
      form.state.values.bezahlung.arbeitszeitkonto.gehaltsempfaenger
        .unbezahlteUeberstundenWoche;
    const values: string[] = [];
    if (wochenstunden) {
      values.push(wochenstunden);
    } else {
      setSummeStunden('');
      return;
    }
    if (ueberstunden) {
      values.push(ueberstunden);
    }

    if (values.length > 0) {
      setSummeStunden(calculateHoursSum(values));
    } else {
      setSummeStunden('');
    }
  };

  useEffect(() => {
    handleSummenCalculation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Body>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.wochenstunden.description',
        )}
      </Body>
      <div className="flex flex-col gap-4">
        <div className="flex gap-4 items-start">
          <form.AppField
            name="bezahlung.arbeitszeitkonto.gehaltsempfaenger.wochenstunden"
            listeners={{
              onBlur: () => {
                handleSummenCalculation();
              },
            }}>
            {(field) => (
              <field.HoursInput
                label={t(
                  'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.wochenstunden.label',
                )}
                isRequired
                suffix="Std."
                placeholder="hh:mm"
              />
            )}
          </form.AppField>
          <form.AppField
            name="bezahlung.arbeitszeitkonto.gehaltsempfaenger.unbezahlteUeberstundenWoche"
            listeners={{
              onBlur: () => {
                handleSummenCalculation();
              },
            }}>
            {(field) => (
              <field.HoursInput
                label={t(
                  'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.unbezahlteUeberstundenWoche.description',
                )}
                suffix="Std."
                placeholder="hh:mm"
              />
            )}
          </form.AppField>
        </div>
        {summeStunden && (
          <Body size={'sm'} className="text-neutrals-800">
            {t(
              'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.wochenstunden.info',
              {
                stunden: summeStunden,
              },
            )}
          </Body>
        )}
      </div>
    </>
  );
}
